import { render, staticRenderFns } from "./AdminTableButton.vue?vue&type=template&id=0235bfad&scoped=true&"
import script from "./AdminTableButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../src/web/assets/admintable/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235bfad",
  null
  
)

export default component.exports